import React, {CSSProperties, FC} from "react";
import {Col, Flex, Row} from "antd";
import {useLocation} from "react-router-dom";
import {useGlobal} from "../../config/GlobalContext";
import "./SBHeader.css";
import SBHeaderSwitch from "./SBHeaderSwitch";
import SBConnect from "./SBConnect";
import MatchDays from "../MatchDays";
import RandomBetButton from "../RandomBetButton";

// Same allowlist as SBRoutes: the phases bar is only useful where the bets are entered.
const SHOW_MATCHDAYS_PATHS = new Set<string>(['/matchs']);

interface SBHeaderProps {
    collapsed: boolean;
    setCollapsed: (collapsed: boolean) => void;
}

const SBHeader: FC<SBHeaderProps> = ({ collapsed, setCollapsed }) => {

    const {showOld, setShowOld} = useGlobal();
    const location = useLocation();
    const showMatchDays = SHOW_MATCHDAYS_PATHS.has(location.pathname);

    const swapHideOld = (e: any) => {
        setShowOld(!showOld);
    }

    const boxStyle: CSSProperties = {
        width: '100%',
        padding: '1px',
    };

    const justify = 'space-between';
    const alignItems = 'flex-start';

    return (
        <>
            <Flex gap="middle" align="start">
                <Flex style={boxStyle} justify={justify} align={alignItems}>
                    <Flex align="center" gap={8}>
                        <SBHeaderSwitch collapsed={collapsed} setCollapsed={setCollapsed}
                                        text={(collapsed ? "Montrer" : "Cacher") + " le menu"}
                        />
                        {showMatchDays && <RandomBetButton/>}
                    </Flex>
                    <SBConnect/>
                    <SBHeaderSwitch collapsed={!showOld} setCollapsed={swapHideOld}
                                    text={(showOld ? "Cacher" : "Montrer") + " les anciens matchs"}
                                    AlignLeft={true}
                    />
                </Flex>
            </Flex>
            {showMatchDays && (
                <Row>
                    <Col span={24}>
                        <MatchDays/>
                    </Col>
                </Row>
            )}
        </>
    )
}

export default SBHeader;